import { MessagingHelper } from "../helpers/MessagingHelper";
import { APIService } from "./APIService";

export class ImportService {
    async ImportFile(formData: FormData): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Import/ImportFile`,
                formData,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(false, "Erro ao importar o ficheiro", null);
        }
    }
}